import { connect } from 'react-redux';

import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  showModal,
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  setCurrentTheme
} from 'zoomforth_codesbane_editor/action_creators/theme.js';

import MapStylePresetsModal
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/map_style_presets_modal_container.jsx';

const mapStateToProps = () => {
  return {
    title: 'This theme is not compatible',
    body: 'Are you sure you would like to select this theme? The styles may not work with the current version of your site. Please preview your site before publishing these changes.',
    confirmText: 'Select theme',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { newThemeData, isMappingStylePresetsRequired }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      if (isMappingStylePresetsRequired) {
        dispatch(showModal(MapStylePresetsModal, { newThemeData }));
      } else {
        dispatch(setCurrentTheme(newThemeData));
        dispatch(closeModal());
      }
    }
  }
);

const ConfirmSelectIncompatibleThemeModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmSelectIncompatibleThemeModal.editorModalName = 'ConfirmSelectIncompatibleThemeModal';

export default ConfirmSelectIncompatibleThemeModal;
